import { useEffect, useRef, useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import TextareaAutosize from 'react-textarea-autosize';
import iconDragDetail from '../icon-drag-detail.svg';
import iconTrash from '../icon-trash.svg';
import { ReactSortable } from 'react-sortablejs';
import _, { cloneDeep, get, debounce, isEmpty } from 'lodash';
import {
  createIngredient,
  createInstruction,
  deleteInstruction,
  orderInstruction,
} from 'actions/recipe';
import AppHelper from 'helpers/AppHelper';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmModal from 'components/Modal/ConfirmModal';
import { getListSection } from "actions/brik";
import { updateRecipe, deleteImageRecipe } from "actions/recipe";
import useStyles from './styles';
import { alertActions } from 'actions/alert.actions';

const Step4 = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { dataCreateInstruction, loadingCreateRecipe, dataCreate, loadingEditRecipe } = useSelector((state: any) => state.recipe);
  const {
    onBackClick,
    register,
    setValue,
    handleSubmit,
    errors,
    onHandleCloseModal,
    listInstructions,
    listIngredients,
    setListInstructions,
    setEditRecipe,
    itemEdit,
    itemEditState,
    isChangeImage,
    isEdit,
    isDuplicate,
    handleCreateRecipe,
    setError,
    editRecipe,
    clearErrors,
    brikId
  } = props;
  const [onEnterPressed, setOnEnterPressed] = useState(false);
  const idError = useRef(listInstructions?.length - 1);
  let lastRef: any = useRef(null);

  const configIngredient = {
    validate: (value: any) => {
      if (value?.trim() === '') {
        return 'Please enter instruction';
      }
      return true;
    },
  };

  const textFormRef = register(configIngredient);

  const getIdError = () => {
    idError.current = idError.current + 1;
    return idError.current;
  };

  const onchangeText = (e: any, key: number) => {
    listInstructions[key].content = e.target.value;
    setEditRecipe(true);
    setListInstructions(cloneDeep(listInstructions));
  };

  const handleShowContentMenu = () => {
    const _data = [...listInstructions];
    _data.push({ content: '', order: _data.length, id: `delete${Math.random()}` });
    setListInstructions(_data);
  };

  const swapError = (
    oldIndex: number,
    newIndex: number,
    listNewIndex: number[]
  ) => {
    if (get(errors, `instruction${oldIndex}`)?.message) {
      const oldError = get(errors, `instruction${oldIndex}`)?.message;
      setError(`instruction${newIndex}`, { message: oldError });
      if (!listNewIndex?.includes(oldIndex)) {
        clearErrors(`instruction${oldIndex}`);
      }
    }
  };

  const onchangeState = (newState: any) => {
    if (newState?.length > 0 && !_.isEqual(newState, listInstructions)) {
      const swapArray: any = [];
      const listNewIndex: any = [];
      _.map(listInstructions, (oldIns, index) => {
        if (get(errors, `instruction${index}`)?.message) {
          const findIndex = _.findIndex(newState, (newInstructor: any) => {
            return newInstructor?.idError === oldIns?.idError;
          });
          if (parseInt(index) !== findIndex) {
            swapArray.push({ old: index, new: findIndex });
            listNewIndex.push(findIndex);
          }
        }
      });

      if (!isEmpty(swapArray)) {
        swapArray.map((item: any) => {
          swapError(parseInt(item?.old), item?.new, listNewIndex);
        });
      }

      const newListInstructions = _.map(newState, (item, index) => {
        return {
          ...item,
          position: index,
          id: item.id,
          order: index,
        };
      });
      setEditRecipe(true);
      setListInstructions(newListInstructions);
    }
  };

  const handleDeteleInstruction = async (indexDelete: number) => {
    const listIdSwaped: any = [];
    clearErrors(`instruction${indexDelete}`);
    for (let i = indexDelete; i < listInstructions?.length - 1; i++) {
      swapError(i + 1, i, listIdSwaped);
      listIdSwaped.push(i);
    }
    // if (listInstructions[indexDelete]?.id) {
    //   dispatch(
    //     deleteInstruction(itemEdit.id, listInstructions[indexDelete]?.id)
    //   );
    // }
    let _listInstructions = _.clone(listInstructions);
    _listInstructions.splice(indexDelete, 1);
    const newListInstructions = _.map(_listInstructions, (item, index) => {
      return {
        ...item,
        order: index,
      };
    });
    if (listInstructions?.length === 1) {
      setListInstructions([{ content: '', order: 0, id: `delete${Math.random()}` }])
    } else {
      setListInstructions(newListInstructions);
    }
    setEditRecipe(true);
  };

  const renderIconTrash = (indexItemDeleted: any) => {
    return (
      <span
        className='content-trash'
        onClick={() => handleDeteleInstruction(indexItemDeleted)}
      >
        <img className={classes.iconTrash} src={iconTrash} alt='' />
      </span>
    );
  };

  const deleteIdFetch = (listData: any) => {
    let newListData = listData.map((item: any) => {
      let checkString = _.isString(item?.id) && item?.id?.startsWith('delete');
      return Object.assign(item, checkString && { id: 0 })
    });
    return newListData;
  }

  const onClickFinishRecipe = async () => {
    if (!isEdit || isDuplicate) {
      await handleCreateRecipe();
    } else {
      const newListInstruction = _.cloneDeep(listInstructions).map(
        (item: any) => {
          return {
            ...item,
            id: item?.id || 0,
          };
        }
      );
      if (brikId) {
        await dispatch(getListSection(brikId))
      }
      if (editRecipe) {
        const params: any = {
          name: itemEditState?.name,
          description: itemEditState?.description,
          servings: itemEditState?.servings,
          prep_hours: itemEditState?.prep_hours,
          prep_minutes: itemEditState?.prep_minutes,
          cook_hours: itemEditState?.cook_hours,
          cook_minutes: itemEditState?.cook_minutes,
          ingredients: deleteIdFetch(listIngredients),
          instructions: deleteIdFetch(newListInstruction),
        };

        if (isChangeImage) {
          params.image = itemEditState?.image;
        }

        await dispatch( updateRecipe(itemEdit.id, params));
        await dispatch(alertActions.success(`Recipe has been edited successfully!`));
      }
      await AppHelper.hideGlobalModal();
    }
    await onHandleCloseModal();
  };

  useEffect(() => {
    if (dataCreateInstruction) {
      let cloneList = cloneDeep(listInstructions);
      cloneList[parseInt(dataCreateInstruction?.order)] = dataCreateInstruction;
      setListInstructions(cloneList);
    }
  }, [dataCreateInstruction]);

  useEffect(() => {
    const shouldReset = _.find(listInstructions, (item) => {
      return !item?.idError;
    });
    if (shouldReset) {
      const newListInstructions = _.map(listInstructions, (item) => {
        return {
          ...item,
          idError: item?.idError ? item?.idError : getIdError(),
        };
      });
      setListInstructions(newListInstructions);
    } else {
      listInstructions.map((item: any, index: any) => {
        setValue(`instruction${index}`, item?.content);
      });
    }

    if (lastRef.current && onEnterPressed) {
      lastRef.current.focus();
      setOnEnterPressed(false);
    }
  }, [listInstructions]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleShowContentMenu()
      setOnEnterPressed(true);
      event.preventDefault();
    }
  }


  return (
    <div className={classes.rootContainer}>
      <div className={classes.container}>
        <ReactSortable
          handle={'.drag-handle'}
          list={listInstructions}
          setList={(newState: any) => onchangeState(newState)}
          direction={'vertical'}
          forceFallback={true}
        >
          {listInstructions.map((item: any, index: any) => {
            return (
              <div className={`${classes.divFlex} text-area`} key={item?.id}>
                <img src={iconDragDetail} alt='' className='drag-handle' />
                <div className={classes.divSubsection}>
                  <span>
                    {itemEdit ? parseInt(item?.order) + 1 : index + 1}.
                  </span>
                  <div style={{ width: '100%' }}>
                    <TextareaAutosize
                      className={classes.inputSubsection}
                      placeholder={`Type the instruction here...`}
                      maxLength={1000}
                      onKeyDown={handleKeyDown}
                      ref={(e) => {
                        textFormRef(e);
                        if (index === listInstructions.length - 1) {
                          lastRef.current = e;
                        } else {
                          lastRef.current = undefined
                        }
                      }}
                      onChange={(e: any) => onchangeText(e, index)}
                      name={`instruction${index}`}
                    />
                    {get(errors, `instruction${index}`)?.message && (
                      <p style={{ color: 'red' }}>
                        {get(errors, `instruction${index}`)?.message}
                      </p>
                    )}
                  </div>
                </div>
                {renderIconTrash(index)}
              </div>
            );
          })}
        </ReactSortable>

        <Button
          variant='text'
          className={classes.btnAddContent}
          onClick={handleShowContentMenu}
        >
          + Add a step
        </Button>
      </div>

      <div className={classes.footerModal}>
        <button className={classes.cancelButton} onClick={onHandleCloseModal}>
          Cancel
        </button>
        <button className={classes.backButton} onClick={onBackClick}>
          Back
        </button>
        <button
          className={classes.nextButton}
          onClick={handleSubmit(onClickFinishRecipe)}
          disabled={loadingCreateRecipe || loadingEditRecipe}
        >
          {isEdit ? 'Save' : 'Create'}
            {(loadingCreateRecipe || loadingEditRecipe) && (
              <span className={classes.iconLoading}>
                <CircularProgress size={16} />
              </span>
            )}
         
        </button>
      </div>
    </div>
  );
};

export default Step4;
